export interface ProductPath {
  description: string | null;
  url: string;
  type: 'INSTALLER' | 'DOWNLOAD' | 'ECLIPSE_UPDATE_SITE' | 'YATTA_PROFILES' | 'EXTERNAL_LINK' | 'DOWNLOAD_PAGE' | 'INVOICE' | 'DOCUMENTATION';
  os: 'ALL' | 'WIN' | 'OSX' | 'LINUX' | 'OTHER' | null;
}
